import { render, staticRenderFns } from "./RedirectIcon.vue?vue&type=template&id=e6951510"
import script from "./RedirectIcon.vue?vue&type=script&lang=js"
export * from "./RedirectIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports